export const preselectedFieldTheme = {
  label: 'palette.tertiary.60',
  text: 'palette.tertiary.90',
};
